export default "__VITE_ASSET__CuYFpMwF__"